<template>
  <div class="row">
    <div class="col order-summary-toggle d-block d-none-md w-100">
      <button class="btn btn-block btn-show" @click="toggleOrderSummary">
        Show order summary
        <i class="fa fa-caret-down"></i>
      </button>

      <div :class="['container p0', shouldShowOrderSummary ? 'show' : '']">
        <div class="cart--side">
          <cart-review />
        </div>
      </div>
    </div>

    <ValidationObserver
      ref="formObserver"
      tag="form"
      class="col-lg-7 mb50-md mb20 pr30-lg"
      @submit.prevent="onSubmit"
    >
      <loader :loading="loading"></loader>
      <checkout-breadcrumbs />

      <contact-info-summary />

      <section class="delivery--block mb30-md mb20">
        <h2 class="main-title tc-custom-red fs22 m0 pb20">Payment</h2>
        <p class="m0 pb20 bb-lightgray">
          All transactions are secured and encrypted.
        </p>

        <ValidationProvider
          rules="required"
          name="Payment Method"
          tag="ul"
          id="accordion"
          class="payment--method"
          v-slot="{ errors }"
        >
          <li
            v-for="(paymentMethod, index) in paymentMethods"
            :key="index"
            class="custom-control custom__radio px0 py15 bb-lightgray"
          >
            <input
              type="radio"
              :id="paymentMethod.slug"
              name="customRadio"
              class="custom-control-input"
              :value="paymentMethod.slug"
              v-model="selectedPaymentMethod"
            />
            <label
              class="custom-control-label d-flex align-items-center"
              :for="paymentMethod.slug"
            >
              <img
                v-if="paymentMethod.icon_source"
                :src="paymentMethod.icon_source"
                :alt="paymentMethod.slug + '_icon'"
                class="mr10"
              />
              <template v-else>
                {{ paymentMethod.title }}
              </template>
              <template v-if="paymentMethod.subtitle">
                {{ paymentMethod.subtitle }}
              </template>
            </label>
            <div
              v-if="paymentMethod.description"
              class="content bt-lightgray"
              v-html="paymentMethod.description"
            ></div>
          </li>
          <span v-if="errors.length > 0" class="label--error text-danger">
            {{ errors[0] }}
          </span>
        </ValidationProvider>
      </section>

      <section
        v-if="deliveryMethod === 'shipping'"
        class="delivery--block pb30-md pb20"
      >
        <h2 class="main-title tc-custom-red fs22">Billing Address</h2>
        <p class="m0 pb20 bb-lightgray">
          Select the address that matches your card or payment method.
        </p>

        <ul id="accordion" class="billing--add">
          <li class="custom-control custom__radio px0 py15 bb-lightgray">
            <input
              type="radio"
              id="same_billing"
              :value="true"
              class="custom-control-input"
              v-model="shouldUseShippingAsBilling"
            />

            <label
              class="custom-control-label d-flex align-items-center"
              for="same_billing"
            >
              Same as shipping address
            </label>
          </li>

          <li class="custom-control custom__radio px0 py15 bb-lightgray">
            <input
              type="radio"
              id="diff_billing"
              :value="false"
              class="custom-control-input"
              v-model="shouldUseShippingAsBilling"
            />

            <label
              class="custom-control-label d-flex align-items-center"
              for="diff_billing"
            >
              Use a different billing address
            </label>
            <div
              v-if="!shouldUseShippingAsBilling"
              class="content bt-lightgray bg-white"
            >
              <div class="row">
                <ValidationProvider
                  rules="required"
                  name="First Name"
                  tag="div"
                  class="col-lg-6 col-sm-12"
                  v-slot="{ errors }"
                >
                  <div class="form-group mb20">
                    <input
                      type="text"
                      name="billing[first_name]"
                      class="webform-control form-control"
                      placeholder="First Name"
                      v-model="billingFirstName"
                    />
                    <span
                      v-if="errors.length > 0"
                      class="label--error text-danger"
                    >
                      {{ errors[0] }}
                    </span>
                  </div>
                </ValidationProvider>
                <ValidationProvider
                  rules="required"
                  name="Last Name"
                  tag="div"
                  class="col-lg-6 col-sm-12"
                  v-slot="{ errors }"
                >
                  <div class="form-group mb20">
                    <input
                      type="text"
                      name="billing[last_name]"
                      class="webform-control form-control"
                      placeholder="Last Name"
                      v-model="billingLastName"
                    />
                    <span
                      v-if="errors.length > 0"
                      class="label--error text-danger"
                    >
                      {{ errors[0] }}
                    </span>
                  </div>
                </ValidationProvider>
                <ValidationProvider
                  rules="required"
                  name="Contact Number"
                  tag="div"
                  class="col-lg-6 col-sm-12"
                  v-slot="{ errors }"
                >
                  <div class="form-group mb20">
                    <input
                      type="text"
                      name="billing[contact_number]"
                      class="webform-control form-control"
                      placeholder="Contact Number"
                      v-model="billingContactNumber"
                    />
                    <span
                      v-if="errors.length > 0"
                      class="label--error text-danger"
                    >
                      {{ errors[0] }}
                    </span>
                  </div>
                </ValidationProvider>
                <ValidationProvider
                  rules="required"
                  name="Unit"
                  tag="div"
                  class="col-lg-6 col-sm-12"
                  v-slot="{ errors }"
                >
                  <div class="form-group mb20">
                    <input
                      type="text"
                      name="billing[unit]"
                      class="webform-control form-control"
                      placeholder="Unit"
                      v-model="billingUnit"
                    />
                    <span
                      v-if="errors.length > 0"
                      class="label--error text-danger"
                    >
                      {{ errors[0] }}
                    </span>
                  </div>
                </ValidationProvider>
                <ValidationProvider
                  rules="required"
                  name="Barangay"
                  tag="div"
                  class="col-lg-6 col-sm-12"
                  v-slot="{ errors }"
                >
                  <div class="form-group mb20">
                    <input
                      type="text"
                      name="billing[barangay]"
                      class="webform-control form-control"
                      placeholder="Barangay"
                      v-model="billingBarangay"
                    />
                    <span
                      v-if="errors.length > 0"
                      class="label--error text-danger"
                    >
                      {{ errors[0] }}
                    </span>
                  </div>
                </ValidationProvider>
                <ValidationProvider
                  rules="required"
                  name="City"
                  tag="div"
                  class="col-lg-6 col-sm-12"
                  v-slot="{ errors }"
                >
                  <div class="form-group mb20">
                    <input
                      type="text"
                      placeholder="City"
                      name="billing[city]"
                      class="webform-control form-control"
                      v-model="billingCity"
                    />
                    <span
                      v-if="errors.length > 0"
                      class="label--error text-danger"
                    >
                      {{ errors[0] }}
                    </span>
                  </div>
                </ValidationProvider>
                <ValidationProvider
                  rules="required"
                  name="Province"
                  tag="div"
                  class="col-lg-6 col-sm-12"
                  v-slot="{ errors }"
                >
                  <div class="form-group mb20">
                    <input
                      type="text"
                      placeholder="Province"
                      name="billing[province]"
                      class="webform-control form-control"
                      v-model="billingProvince"
                    />
                    <span
                      v-if="errors.length > 0"
                      class="label--error text-danger"
                    >
                      {{ errors[0] }}
                    </span>
                  </div>
                </ValidationProvider>
                <ValidationProvider
                  rules="required"
                  name="Postal Code"
                  tag="div"
                  class="col-lg-6 col-sm-12"
                  v-slot="{ errors }"
                >
                  <div class="form-group mb20">
                    <input
                      type="text"
                      class="webform-control form-control"
                      name="billing[postal_code]"
                      placeholder="Postal Code*"
                      v-model="billingPostalCode"
                    />
                    <span
                      v-if="errors.length > 0"
                      class="label--error text-danger"
                    >
                      {{ errors[0] }}
                    </span>
                  </div>
                </ValidationProvider>
                <ValidationProvider
                  rules="required"
                  name="Country"
                  tag="div"
                  class="col-sm-12"
                  v-slot="{ errors }"
                >
                  <div class="form-group mb20">
                    <div class="select--country">
                      <label for="country">Country/Region</label>
                      <select
                        id="country"
                        class="form-control"
                        name="billing[country]"
                        autocomplete="off"
                        v-model="billingCountry"
                      >
                        <option selected value="PH">Philippines</option>
                      </select>
                    </div>
                    <span
                      v-if="errors.length > 0"
                      class="label--error text-danger"
                    >
                      {{ errors[0] }}
                    </span>
                  </div>
                </ValidationProvider>
                <div v-if="!isAuthUser" class="col-sm-12">
                  <div class="form-check custom__checkbox">
                    <input
                      id="save-add"
                      class="form-check-input"
                      type="checkbox"
                      v-model="shouldSaveInfo"
                    />
                    <label for="save-add" class="form-check-label">
                      Save this information for the next time
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </section>

      <section class="delivery--block">
        <h2 class="main-title tc-custom-red fs22 mt0">Discount Information</h2>
        <template v-if="couponInfo == null">
          <p class="m0 pb20 bb-lightgray">Apply Voucher</p>
        </template>
        <template v-else>
          <p class="m0 pb20 bb-lightgray">Applied Voucher</p>
        </template>

        <div class="row py20" v-if="couponInfo == null">
          <div class="form-group mb20 col-sm-8">
            <input
              type="text"
              name="voucher"
              class="webform-control form-control"
              placeholder="Apply Voucher"
              v-model="voucherCode"
            />
          </div>

          <div class="form-group mb20 col-sm-4">
            <div class="main-btn p0">
              <button type="button" v-on:click="applyCoupon">
                Apply Voucher
              </button>
            </div>
          </div>
        </div>

        <div class="row py20" v-else>
          <div class="container bb-lightgray row">
            <div class="form-group mb20 col-sm-8">
              <p class="m0 pb20 fs14">Code : {{ couponInfo.voucher.code }}</p>

              <p class="m0 pb20 fs14">
                Voucher/Promo Name: {{ couponInfo.voucher.title }}
              </p>

              <p class="m0 pb20 fs14">
                Voucher Discount:
                {{ discount(couponInfo.discount) | moneyToCurrencyFormat }}
              </p>
            </div>
            <div class="form-group mb20 col-sm-4">
              <div class="main-btn p0">
                <button type="button" v-on:click="removeCoupon">
                  Remove Voucher
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        class="action-btn d-flex align-items-center justify-content-between flex-sm-row flex-column-reverse mt30-md mt20"
      >
        <div>
          <router-link
            v-if="deliveryMethod === 'shipping'"
            class="main-link"
            :to="{ name: 'shipping' }"
          >
            &#60; Return to Shipping
          </router-link>
          <router-link v-else class="main-link" :to="{ name: 'information' }">
            &#60; Return to Information
          </router-link>
        </div>
        <div class="main-btn px0">
          <button type="submit">Complete Order</button>
        </div>
      </section>
    </ValidationObserver>

    <div class="col-lg-5 cart--side pt10">
      <cart-review />
    </div>
  </div>
</template>

<script>
import CheckoutBreadcrumbs from "../components/checkout/CheckoutBreadcrumbs";
import ContactInfoSummary from "../components/checkout/ContactInfoSummary";
import CartReview from "../components/checkout/CartReview";
import Loader from "../components/Loader";
import payment from "../api/payment";
import paymentMethod from "../api/paymentMethod";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapStateWithMutation } from "../helpers/vuexHelpers";
import storage from "../helpers/storage";
import applyvoucher from "../api/coupon";

export default {
  components: {
    CheckoutBreadcrumbs,
    ContactInfoSummary,
    CartReview,
    Loader,
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      loading: false,
      paymentMethods: [],
      shouldShowOrderSummary: false,
      shouldUseShippingAsBilling: true,
      shouldSaveInfo: false,
    };
  },
  computed: {
    userVoucher() {
      return this.$store.state.checkout.voucher;
    },
    isAuthUser() {
      return this.$store.state.checkout.isAuthUser;
    },
    contactNumber() {
      return this.$store.state.checkout.contact.contactNumber;
    },
    shippingAddress() {
      return this.$store.getters["checkout/fullShippingAddress"];
    },
    deliveryMethod() {
      return this.$store.state.checkout.deliveryMethod;
    },
    ...mapStateWithMutation("checkout", {
      selectedPaymentMethod: {
        state: (state) => state.paymentMethod,
        mutation: "UPDATE_PAYMENT_METHOD",
      },
      billingFirstName: {
        state: (state) => state.billing.firstName,
        mutation: "UPDATE_BILLING_FIRST_NAME",
      },
      billingLastName: {
        state: (state) => state.billing.lastName,
        mutation: "UPDATE_BILLING_LAST_NAME",
      },
      billingContactNumber: {
        state: (state) => state.billing.contactNumber,
        mutation: "UPDATE_BILLING_CONTACT_NUMBER",
      },
      billingUnit: {
        state: (state) => state.billing.unit,
        mutation: "UPDATE_BILLING_UNIT",
      },
      billingBarangay: {
        state: (state) => state.billing.barangay,
        mutation: "UPDATE_BILLING_BARANGAY",
      },
      billingCity: {
        state: (state) => state.billing.city,
        mutation: "UPDATE_BILLING_CITY",
      },
      billingProvince: {
        state: (state) => state.billing.province,
        mutation: "UPDATE_BILLING_PROVINCE",
      },
      billingPostalCode: {
        state: (state) => state.billing.postalCode,
        mutation: "UPDATE_BILLING_POSTAL_CODE",
      },
      billingCountry: {
        state: (state) => state.billing.country,
        mutation: "UPDATE_BILLING_COUNTRY",
      },
      voucherCode: {
        state: (state) => state.voucher,
        mutation: "UPDATE_COUPON",
      },
      couponInfo: {
        state: (state) => state.couponinfo,
        mutation: "SET_COUPONINFO",
      },
    }),
  },
  async created() {
    this.loading = true;
    const {
      data: { payment_methods },
    } = await paymentMethod.all();

    this.paymentMethods = payment_methods;
    this.loading = false;
  },
  async activated() {
    this.loading = true;

    await this.$store.dispatch("checkout/computeDiscount");

    this.loading = false;
  },
  methods: {
    async onSubmit(event) {
      const isValid = await this.$refs.formObserver.validate();

      if (!isValid) {
        return;
      }

      if (this.shouldUseShippingAsBilling) {
        this.billingFirstName = this.$store.state.checkout.shipping.firstName;
        this.billingLastName = this.$store.state.checkout.shipping.lastName;
        this.billingContactNumber = this.$store.state.checkout.shipping.contactNumber;
        this.billingUnit = this.$store.state.checkout.shipping.unit;
        this.billingBarangay = this.$store.state.checkout.shipping.barangay;
        this.billingCity = this.$store.state.checkout.shipping.city;
        this.billingProvince = this.$store.state.checkout.shipping.province;
        this.billingPostalCode = this.$store.state.checkout.shipping.postalCode;
        this.billingCountry = this.$store.state.checkout.shipping.country;
      }

      if (this.shouldSaveInfo) {
        storage.update("_billing", {
          firstName: this.billingFirstName,
          lastName: this.billingLastName,
          contactNumber: this.billingContactNumber,
          unit: this.billingUnit,
          barangay: this.billingBarangay,
          city: this.billingCity,
          province: this.billingProvince,
          postalCode: this.billingPostalCode,
          country: this.billingCountry,
        });
      }

      try {
        this.loading = true;
        const { data } = await payment.send({
          provider: this.selectedPaymentMethod,
          payload: this.$store.getters["checkout/paymentPayload"],
        });

        if (data.redirect || false) {
          location.assign(data.redirect);
        }
      } catch (error) {
        if (error.response && error.response.status === 422) {
          Object.keys(error.response.data.errors).forEach((key) =>
            this.$toasted.show(error.response.data.errors[key], {
              icon: { name: "fa-times" },
            })
          );
        } else {
          this.$toasted.show("Oops, something went wrong...", {
            icon: { name: "fa-times" },
          });
          console.error(error);
        }

        this.loading = false;
      }
    },
    toggleOrderSummary() {
      this.shouldShowOrderSummary = !this.shouldShowOrderSummary;
    },

    async applyCoupon() {
      try {
        this.loading = true;
        const { data } = await applyvoucher.send(
          this.$store.getters["checkout/paymentPayload"]
        );

        this.couponInfo = data;

        await this.$store.dispatch("checkout/computeDiscount");
      } catch (error) {
        this.$toasted.show("Submit Invalid Coupon/Voucher", {
          icon: { name: "fa-times" },
        });
        console.log(error);

        this.voucherCode = null;

        this.couponInfo = null;
      }
      this.loading = false;
    },

    discount(d) {
      return {
        amount: parseInt(d.amount),
        currency: d.currency,
      };
    },

    async removeCoupon() {

      this.loading = true;
        this.voucherCode = null;
        this.couponInfo = null;
        await this.$store.dispatch("checkout/computeDiscount");
      this.loading = false;
    },
  },
};
</script>

<style></style>
